export default __webpack_public_path__ + "static/media/warning.b1d3c548.png";